import { usePopper } from "react-popper";
import { useState } from "react";

import { useSameWidthModifiers } from "./useSameWidthModifiers";

type Placement =
  | "top-start"
  | "top-end"
  | "bottom-start"
  | "bottom-end"
  | "right-start"
  | "right-end"
  | "left-start"
  | "left-end"
  | "auto"
  | "auto-start"
  | "auto-end"
  | "top"
  | "bottom"
  | "right"
  | "left";

export function usePopperBasic(placement: Placement) {
  const [referenceElement, setReferenceElement] = useState<any>(null);
  const [popperElement, setPopperElement] = useState<any>(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, { placement });
  return {
    style: styles.popper,
    attrs: attributes.popper,
    setReferenceElement,
    setPopperElement,
  };
}

export function usePopperSameWidth(placement: Placement) {
  const [referenceElement, setReferenceElement] = useState<any>(null);
  const [popperElement, setPopperElement] = useState<any>(null);
  const modifiers = useSameWidthModifiers();
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement,
    modifiers,
  });
  return {
    style: styles.popper,
    attrs: attributes.popper,
    setReferenceElement,
    setPopperElement,
  };
}
